import React, { Component, Fragment } from "react";
import { connect } from "react-redux";
import { CONFIG, CONFIG_API_BE, URL_AKM } from "../../../../../config";
import { cekCookies } from "../../../../../actions";
import __ from "lodash";
import LoaderModal from "../../../../modal/LoaderModal";
import Navbar from "../../../navbar/Navbar";
import Sidebar from "../../../sidebar/Sidebar";
import accountManagement from "../../../../../apis/accountManagement";
import eduprimeApi from "../../../../../apis/eduprimeApi";
import akmApi from "../../../../../apis/akmApi";
import StudentPasswordRecovery from '../../../../recovery/StudentPasswordRecovery';

import { Row, Col, Alert, Modal, Tabs, Tab, Button, Card } from "react-bootstrap";
import { Grid, TableCell, TableContainer, Table, TableHead, TableRow, TextField, Typography, TableBody } from "@material-ui/core";

class SearchDetailAktivasiSiswa extends Component {
  constructor(props) {
    super(props);
    this.state = {
      error: null,
      resMessage: "",
      alertShow: false,
      isFetching: false,
      searchUsername: null,
      dataSekolah: {},
      dataSiswa: {},
      listVoucher: [],
      listAllSiswa: [],
    };
  }
  async componentDidMount() {
    await this.props.cekCookies();
  }

  handleSearchSiswa = async (e) => {
    e.preventDefault();
    this.setState({
      isFetching: true,
      alertShow: false,
      dataSekolah: {},
      dataSiswa: {},
      listVoucher: [],
      listAllSiswa: [],
    });

    const { searchUsername } = this.state;
    await akmApi
      .get(URL_AKM.SEARCH_DETAIL_SISWA + searchUsername)
      .then((res) => {
        if (res.data.errorSchema.errorCode === URL_AKM.SUCCESS_ERROR_CODE) {
          this.setState({
            // dataSekolah: res.data.data.sekolah,
            // dataSiswa: res.data.data.siswa,
            // listVoucher: res.data.data.voucher,
            listAllSiswa: res.data.data,
            isFetching: false,
          });
        } else {
          this.setState({
            alertShow: true,
            keterangan: res.data.errorSchema.errorMessage,
            isFetching: false,
          });
        }
      })
      .catch((err) => {
        this.setState({isFetching:false, alertShow:true, keterangan:'Pencarian belum berhasil. Periksa koneksi dan sesi Anda.'});
      });
  };

  render() {
    const { dataSiswa, dataSekolah, listVoucher, isFetching, searchUsername, listAllSiswa } = this.state;
    return (
      <div className="wrapper">
        <LoaderModal isFetching={isFetching} />
        <Sidebar account={this.props.account} />
        <div id="content" style={{ paddingBottom: "50px" }}>
          <Navbar title={"Cari Siswa"} />
          {this.loadAlert()}
          <p>Untuk siswa lupa sandi, cari username lalu pilih Reset Password pada hasil pencarian.</p>
          <form onSubmit={this.handleSearchSiswa}>
            <Grid container spacing={1}>
              <Grid item xs={12} sm={6} lg={3}>
                <TextField
                  required
                  id="searchUsername"
                  variant="outlined"
                  size="small"
                  label="Username"
                  type="text"
                  fullWidth
                  value={searchUsername}
                  onChange={(e) => this.setState({ searchUsername: e.target.value })}
                />
              </Grid>
              <Grid item xs={12} sm={2} lg={2}>
                <Button type="submit" variant="primary" style={{ width: "100%" }}>
                  Cari
                </Button>
              </Grid>

              {!__.isEmpty(listAllSiswa) && (
                <Fragment>
                  <TableContainer role="region" aria-label="Hasil pencarian siswa" tabIndex={0} style={{ minWidth: 0 }}>
                  <Table>
                    <TableHead>
                      <TableRow>
                        <TableCell align="left">No</TableCell>
                        <TableCell align="left">Siswa</TableCell>
                        <TableCell align="left">Sekolah</TableCell>
                        <TableCell align="left">voucher || PP</TableCell>
                        <TableCell align="left">Pemulihan akun</TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {listAllSiswa.map((item, index) => {
                        return (
                          <TableRow key={index}>
                            <TableCell align="left">{index + 1}</TableCell>
                            <TableCell align="left">
                              {item.siswa.namaSiswa} /{item.siswa.usernameSiswa}
                              {" (" + item.siswa.idSiswa + ")"}
                            </TableCell>
                            <TableCell align="left">
                              {item.sekolah.namaSekolah} / {item.sekolah.usernameSekolah} {" (" + item.sekolah.idSekolah + ")"}
                            </TableCell>
                            <TableCell align="left">
                              {item.voucher.map((vaoucher, indexVoucher) => {
                                return (
                                  <Fragment key={indexVoucher}>
                                    <Grid container spacing={1}>
                                      <Grid item>
                                        <Typography variant="body2" color="textSecondary">
                                          {vaoucher.kodeVoucher + " (" + vaoucher.activationDate + ")"} || {vaoucher.paketProgram.namaPaketProgram}
                                        </Typography>
                                      </Grid>
                                    </Grid>
                                  </Fragment>
                                );
                              })}
                            </TableCell>
                            <TableCell align="left">
                              <StudentPasswordRecovery key={item.siswa.idSiswa} idSiswa={item.siswa.idSiswa}
                                idSekolah={item.sekolah.idSekolah} username={item.siswa.usernameSiswa}
                                canRecover={['1','4','6'].includes(String(this.props.account.idRole)) && !this.props.account.idSekolah} />
                            </TableCell>
                          </TableRow>
                        );
                      })}
                    </TableBody>
                  </Table>
                  </TableContainer>
                </Fragment>
              )}

              <Grid item></Grid>
            </Grid>
          </form>
        </div>
      </div>
    );
  }

  loadAlert = () => {
    const { alertShow, keterangan } = this.state;

    if (alertShow) {
      return (
        <Alert variant="info" onClose={() => this.setState({ alertShow: false })} dismissible>
          <strong>{keterangan}</strong>
        </Alert>
      );
    }
  };
}
const mapStateToProps = (state) => {
  return {
    account: state.account,
  };
};

export default connect(mapStateToProps, { cekCookies })(SearchDetailAktivasiSiswa);
